import { useRef } from 'react';
import './App.css';
import Hero from './components/Hero/Hero.jsx';
import Contact from './components/Contact/Contact.jsx';
import Header from './components/Header/Header.jsx';
//import Partners from "./components/Partners/Partners.jsx";
import Services from './components/Services/Sevices.jsx';
import About from './components/About/About.jsx';
import Footer from './components/Footer/Footer.jsx';
import 'aos/dist/aos.css'
import Highlights from './components/Highlights/Highlights.jsx';
import HeaderMobile from './components/HeaderMobile/HeaderMobile.jsx';
import useWindowSize from './hooks/useWindowSize.jsx';


const App = () => {

  const HeroRef = useRef(null);
  const ServicesRef = useRef(null);
  const AdvantagesRef = useRef(null);
  const AboutRef = useRef(null);
  const ContactRef = useRef(null);
  const refs = [HeroRef, ServicesRef, AdvantagesRef, AboutRef, ContactRef]
  const windowSize = useWindowSize();

  return (
    <div className="App">
      {windowSize.width < 992 ? <HeaderMobile refs={refs} /> : <Header refs={refs} />}
      <div className="sections">
        <div className="main-back">
          <Hero ref={HeroRef} aboutRef={AboutRef} />
          <Services ref={ServicesRef} />
          <Highlights ref={AdvantagesRef}/>
        </div>
        <About ref={AboutRef} />
        <Contact ref={ContactRef} />
        <Footer />
      </div>
    </div>
  );
}

export default App;
